module.exports = __webpack_public_path__ + "assets/images/amigos-en-miniban-bajatuseguro.jpg";